import { Button, Checkbox, Col, Row, Table, Typography } from "antd";
import { showError } from "common/ToastNotifications";
import { LoadingOverlay } from "components";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Text } = Typography;

class SystemConnectionHubspotObjectFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingDescribe: false,
            fetchingPreview: false,
            selectedFieldNames: [],
        };
    }

    componentWillMount() {
        this.setState({ fetchingDescribe: true });
        this.props.getHubspotObjectDescribe(this.props.connectionId, this.props.objectName);
    }

    componentDidUpdate(prevProps) {
        // Handle Describe Result
        if (this.props.getHubspotObjectDescribeResult && this.props.getHubspotObjectDescribeResult !== prevProps.getHubspotObjectDescribeResult) {
            if (!this.props.getHubspotObjectDescribeResult.success) {
                showError("Could not get HubSpot object schema at this moment.");
            }
            this.setState({ fetchingDescribe: false });
        }

        // Handle Preview Result
        const prevPreview = prevProps.getHubspotObjectPreviewResult;
        const nextPreview = this.props.getHubspotObjectPreviewResult;
        if (prevPreview !== nextPreview) {
            this.setState({ fetchingPreview: false });
            if (nextPreview && nextPreview.success) {
                const rows = this.props.hubspotObjectPreview;
                const columns = this.state.selectedFieldNames;
                // Pass full field info (name, label, type) for schema creation
                const selectedFields = (this.props.hubspotObjectDescribe?.fields || []).filter(f => columns.includes(f.name));
                this.props.onPreviewComplete({ data: rows, columns, fields: selectedFields, tableName: this.props.objectName });
            } else if (nextPreview && !nextPreview.success) {
                showError(nextPreview.message || "Failed to load Data Preview from HubSpot.");
            }
        }
    }

    handleFieldToggle = (fieldName, checked) => {
        this.setState(prevState => {
            if (checked) {
                return { selectedFieldNames: [...prevState.selectedFieldNames, fieldName] };
            } else {
                return { selectedFieldNames: prevState.selectedFieldNames.filter(name => name !== fieldName) };
            }
        });
    }

    handleSelectAll = (e) => {
        if (e.target.checked) {
            const allFieldNames = (this.props.hubspotObjectDescribe?.fields || []).map(f => f.name);
            this.setState({ selectedFieldNames: allFieldNames });
        } else {
            this.setState({ selectedFieldNames: [] });
        }
    }

    handlePreviewData = () => {
        if (this.state.selectedFieldNames.length === 0) {
            showError("Please select at least one field to import.");
            return;
        }
        this.setState({ fetchingPreview: true });
        this.props.getHubspotObjectPreview(this.props.connectionId, this.props.objectName, this.state.selectedFieldNames, 100);
    };

    render() {
        const describe = this.props.hubspotObjectDescribe;
        const fields = describe?.fields || [];
        const selectedCount = this.state.selectedFieldNames.length;
        const allSelected = fields.length > 0 && selectedCount === fields.length;
        const someSelected = selectedCount > 0 && selectedCount < fields.length;

        const columns = [
            {
                title: (
                    <Checkbox
                        indeterminate={someSelected}
                        onChange={this.handleSelectAll}
                        checked={allSelected}
                    />
                ),
                dataIndex: 'name',
                width: 50,
                render: (name) => (
                    <Checkbox
                        checked={this.state.selectedFieldNames.includes(name)}
                        onChange={(e) => this.handleFieldToggle(name, e.target.checked)}
                    />
                )
            },
            {
                title: 'Field Label',
                dataIndex: 'label',
            },
            {
                title: 'API Name',
                dataIndex: 'name',
                render: (val) => <Text type="secondary">{val}</Text>
            },
            {
                title: 'Type',
                dataIndex: 'type',
            }
        ];

        return (
            <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
                <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%", gap: "16px" }}>
                    <LoadingOverlay busy={this.state.fetchingDescribe || this.state.fetchingPreview} spinner message={"Communicating with HubSpot..."}></LoadingOverlay>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                            <Typography.Title level={5} style={{ margin: 0 }}>
                                Fields for {this.props.objectName}
                            </Typography.Title>
                            <Typography.Text type="secondary">
                                {selectedCount} field(s) selected
                            </Typography.Text>
                        </div>
                        <Button
                            type="primary"
                            onClick={this.handlePreviewData}
                            disabled={selectedCount === 0 || this.state.fetchingPreview || this.state.fetchingDescribe}
                        >
                            {this.props.importButtonLabel || "Preview & Import"}
                        </Button>
                    </div>

                    <Table
                        size="small"
                        rowKey="name"
                        dataSource={fields}
                        columns={columns}
                        pagination={false}
                        scroll={{ y: "60vh" }}
                    />
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        getHubspotObjectDescribeResult: state.systemConnectionHubspot.getHubspotObjectDescribeResult,
        hubspotObjectDescribe: state.systemConnectionHubspot.hubspotObjectDescribe,
        getHubspotObjectPreviewResult: state.systemConnectionHubspot.getHubspotObjectPreviewResult,
        hubspotObjectPreview: state.systemConnectionHubspot.hubspotObjectPreview,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHubspotObjectDescribe: (connectionId, objectName) => dispatch(actions.getHubspotObjectDescribeRequest(connectionId, objectName)),
        getHubspotObjectPreview: (connectionId, objectName, fields, limit) => dispatch(actions.getHubspotObjectPreviewRequest(connectionId, objectName, fields, limit)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SystemConnectionHubspotObjectFields));
